import React from 'react';
import { actionIcons } from '../../../../../configs/Icons';

function ColorMode({ onClick }) {
    return (
        <button onClick={onClick} type="button" className="select-none w-6 h-6">
            <img src={actionIcons.sunW} alt="Light Mode" className="w-full dark:hidden " />
            <img
                src={actionIcons.moonD}
                alt="Dark Mode"
                className="w-full hidden dark:block bg-gray-700"
            />
        </button>
    );
}

export default ColorMode;
